import db from '@/firebase/init'
import {firestore} from 'firebase/app'

export function postEnquiryToFirebase (email, name, message, contactReason) {
    try {
        const date = new Date()
             db.collection(process.env.VUE_APP_DB_LEADS).add({
               email: email,
               name: name,
               message: {
                subject: 'Enquiry through website',
                text: message,
                html: message,
              },
               reason: contactReason,
               status: 0,
               response: 0,
               date_updated: firestore.Timestamp.fromDate(date),
               date_created: firestore.Timestamp.fromDate(date),
               to: 'afletcher53@gmail.com',
             })
           } catch (error) {
             console.log(error)
           }
       
  }
  
  export async function getAllLeads () {
  const leads = db.collection('enquiries')
  const data = []

  await leads.get()
    .then(snapshot => {
      snapshot.forEach(doc => {
        data.push(doc.data())
      })
    })
    .catch(err => {
      console.log('Error getting documents', err)
    })
  return data
}
